import React from 'react';
import { measurementUnitsActions } from './store';

export default function LoadMeasurementUnits() {
    React.useEffect(() => measurementUnitsActions.load(), []);

    return null;
}
